import React from 'react';
import {FiX} from "react-icons/fi";
import dayjs from "dayjs";
import LazyFlatPicker from "@/components/LazyFlatPicker.tsx";

export default function DateTimePicker({
     value,
     onChange,
     placeholder,
}:{
    value?: string,
    onChange: (value: string) => void,
    placeholder?: string
 }) {
    return (
        <div className={"input input-bordered flex items-center gap-2"}>
            <LazyFlatPicker
                config={{
                    enableTime:true,
                    minDate:dayjs().subtract(1, 'hour').toDate()
                }}
                value={value}
                placeholder={placeholder}
                onChange={([date]) => {
                    onChange(date)
                }}
            />
            {
                value ?
                    <button onClick={()=>{
                        onChange(null)
                    }} className="input-group-text" id="basic-addon1">
                        <FiX />
                    </button> : null
            }
        </div>
    );
}
